export default __webpack_public_path__ + "static/media/team4.ef78696e.png";